import { useContext } from 'react'

import { type TSidebarContext, SidebarContext } from '@/shared/components/ui/sidebar/sidebar.provider'

export const useSidebar = () => {
  const context = useContext<TSidebarContext | null>(SidebarContext)
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider.')
  }
  return context
}
